import humanizeUtil from '@utils/humanizeUtil';
import { LESS_THAN_NUMBER } from '@utils/metrics';
import { IMPROVEMENT_OPPORTUNITY_METRICS } from '@src/utils/kpi';

export const sortKPIMetricsData = (data = {}) => {
  const resultArray = IMPROVEMENT_OPPORTUNITY_METRICS.map((item) => ({
    name: item,
    value: data[item],
  }));
  return resultArray.sort((a, b) => (b.value ?? 0) - (a.value ?? 0));
};

export const getMetricTitle = (metricKey, value) => {
  if (isNaN(value)) {
    return 'NA';
  }
  if (value === undefined) {
    return 'NA';
  }
  if (value < LESS_THAN_NUMBER && value > 0) {
    return '<'.concat(LESS_THAN_NUMBER);
  }
  const { humanizedNumber, humanizedUnit } = humanizeUtil(value, metricKey);
  return `${humanizedNumber} ${humanizedUnit}`.trimEnd();
};
